import React from 'react';
import PropTypes from 'prop-types';
import BaseWidget from '../BaseWidget';
import CountdownTimer from './CountdownTimer.js';
import CircleClasses from 'nucleus-core/less/cv/Countdown.Circle.structure.less';
import FlipClasses from 'nucleus-core/less/cv/Countdown.Flip.structure.less';
import { resolveTestId } from '@cvent/nucleus-test-automation';

const CountdownCircleStyle = {
  container: CircleClasses.container,
  countdown: CircleClasses.countdown,
  circle: CircleClasses
};
const CountdownFlipStyle = {
  container: FlipClasses.container,
  countdown: FlipClasses.countdown,
  flip: FlipClasses
};

/**
* Data wrapper for the CountdownTimer widget.
*/
export default class CountdownTimerWidget extends BaseWidget {
  static displayName = 'CountdownTimerWidget';
  static propTypes = {
    config: PropTypes.shape({}), // have different Component for flip and circle ???
    style: PropTypes.object,
    translate: PropTypes.func
  };
  getStyleObject() {
    const counterBackground = this.getElementBackground('counter');
    if (this.props.config.type === 'flip') {
      counterBackground.borderRadius = 5;
    }
    return {
      ...super.getStyleObject(),
      spacing: this.getElementSpacing('counter'),
      background: counterBackground,
      digit: this.getElementText('counter'),
      timer: this.getElementInlineStyle('counter'),
      label: this.getElementInlineStyle('text')
    };
  }
  render() {
    const { config, translate } = this.props;
    const inlineStyles = this.getStyleObject();
    const mergedStyles = {
      countdown: inlineStyles.container,
      circle: {
        counter: inlineStyles.spacing,
        circle: inlineStyles.background,
        digit: inlineStyles.digit,
        label: inlineStyles.label,
        border: inlineStyles.timer
      },
      flip: {
        counter: inlineStyles.spacing,
        top: inlineStyles.background,
        bottom: inlineStyles.background,
        flip: inlineStyles.background,
        digit: inlineStyles.digit,
        digitTop: inlineStyles.digit,
        label: inlineStyles.label
      }
    };
    const classes = config.type === 'circle' ? CountdownCircleStyle : CountdownFlipStyle;
    const endDate = new Date(config.date);
    return (
      <CountdownTimer
        {...resolveTestId(this.props)}
        classes={classes}
        endDate={endDate}
        style={mergedStyles}
        type={config.type}
        daysLabel={translate('_dateLabels_days__resx')}
        showDays={config.showDays}
        hoursLabel={translate('_dateLabels_hours__resx')}
        showHours={config.showHours}
        minutesLabel={translate('_dateLabels_minutes__resx')}
        showMinutes={config.showMinutes}
        secondsLabel={translate('_dateLabels_seconds__resx')}
        showSeconds={config.showSeconds} />
    );
  }
}



// WEBPACK FOOTER //
// ./~/nucleus-widgets/lib/CountdownTimer/CountdownTimerWidget.js